module.exports = __webpack_public_path__ + "static/img/s2.4aa31dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/s2.png
// module id = CWqI
// module chunks = 1